export const toggleRowState = (
  currentOpenedRow: number | null,
  index: number
) => (currentOpenedRow === index ? null : index);

export const toggleStarState = (selectedStars: number[], index: number) =>
  selectedStars.includes(index)
    ? selectedStars.filter((i) => i !== index)
    : [...selectedStars, index];
